module.exports = __webpack_public_path__ + "604d52fc8a36552909007318fb449ca0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Round@2x.png
// module id = 326
// module chunks = 0